import { render, staticRenderFns } from "./Gaozhidanzhao.vue?vue&type=template&id=ffda8edc&scoped=true"
import script from "./Gaozhidanzhao.vue?vue&type=script&lang=js"
export * from "./Gaozhidanzhao.vue?vue&type=script&lang=js"
import style0 from "./Gaozhidanzhao.vue?vue&type=style&index=0&id=ffda8edc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda8edc",
  null
  
)

export default component.exports